export default __webpack_public_path__ + "static/media/consort_diagram004B.7e2550f1.png";